'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.FileUploadDragDrop = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styles = require('@material-ui/core/styles');

var _actions = require('@manakin/core/dist/actions');

var _recompose = require('recompose');

var _reactRedux = require('react-redux');

var _pica = require('../FileUpload/pica');

var _pica2 = _interopRequireDefault(_pica);

var _reactFileDrop = require('react-file-drop');

var _reactI18next = require('react-i18next');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var pica = (0, _pica2.default)({ features: ['all'] });

var styles = function styles(theme) {
	return {
		root: {
			position: 'relative',
			display: 'inline-block'
		},
		input: {
			position: 'absolute',
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			opacity: 0
		}
	};
};

var FileUploadDragDrop = exports.FileUploadDragDrop = function (_React$PureComponent) {
	_inherits(FileUploadDragDrop, _React$PureComponent);

	function FileUploadDragDrop() {
		var _ref,
		    _this2 = this;

		var _temp, _this, _ret;

		_classCallCheck(this, FileUploadDragDrop);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FileUploadDragDrop.__proto__ || Object.getPrototypeOf(FileUploadDragDrop)).call.apply(_ref, [this].concat(args))), _this), _this.handleFileUpload = function (file) {
			var onFilesUpload = _this.props.onFilesUpload;

			_this.validateOrCompressImage(file).then(function (newFile) {
				if (newFile) {
					onFilesUpload([newFile]);
				}
			});
		}, _this.validateOrCompressImage = function (file) {
			return new Promise(function (resolve, reject) {
				var _this$props = _this.props,
				    _this$props$fileSizeL = _this$props.fileSizeLimit,
				    fileSizeLimit = _this$props$fileSizeL === undefined ? 5 : _this$props$fileSizeL,
				    processFileTooBig = _this$props.processFileTooBig,
				    t = _this$props.t;


				if (!file.type.endsWith('jpg') && !file.type.endsWith('png') && !file.type.endsWith('jpeg') && !file.type.endsWith('docx') && !file.type.endsWith('application/vnd.openxmlformats-officedocument.wordprocessingml.document') && !file.type.endsWith('pdf')) {
					reject();
				}

				var fileSize = file.size / 1024 / 1024;
				if (fileSize <= fileSizeLimit / 2) {
					resolve(file);
				} else {
					// Try to compress the image
					try {
						if (file.type.startsWith('image')) {
							_this.compressImage(file).then(function (blob) {
								resolve(blob);
							});
						} else {
							// We cannot compress files other than images
							reject();
							processFileTooBig(fileSizeLimit, t);
						}
					} catch (e) {
						if (fileSize > fileSizeLimit) {
							reject();
							processFileTooBig(fileSizeLimit, t);
						} else {
							resolve(file);
						}
					}
				}
			});
		}, _this.compressImage = function (file) {
			return new Promise(function (resolve) {
				var _this$props2 = _this.props,
				    _this$props2$fileSize = _this$props2.fileSizeLimit,
				    fileSizeLimit = _this$props2$fileSize === undefined ? 5 : _this$props2$fileSize,
				    processFileTooBig = _this$props2.processFileTooBig,
				    t = _this$props2.t;


				var image = new Image();
				var canvas = document.createElement('canvas');
				image.src = URL.createObjectURL(file);
				image.onload = function () {
					canvas.width = image.width;
					canvas.height = image.height;

					pica.resize(image, canvas).then(function (result) {
						return pica.toBlob(result, file.type, 0.65);
					}).then(function (result) {
						var resultFileSize = result.size / 1024 / 1024;
						if (resultFileSize > fileSizeLimit) processFileTooBig(fileSizeLimit, t);else {
							result.name = file.name;
							resolve(result);
						}
					});
				};
			});
		}, _this.handleFileDrop = function () {
			var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(newFiles) {
				var _this$props3, onFilesUpload, _this$props3$maxFiles, maxFiles, accept;

				return regeneratorRuntime.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_this$props3 = _this.props, onFilesUpload = _this$props3.onFilesUpload, _this$props3$maxFiles = _this$props3.maxFiles, maxFiles = _this$props3$maxFiles === undefined ? 1 : _this$props3$maxFiles, accept = _this$props3.accept;

								// Loop through all files, filtering for accepted types and also validating whether
								// the files exceed the file limit and should be compressed

								Promise.all(Object.keys(newFiles).map(function (fileKey) {
									return newFiles[fileKey];
								}).filter(function (file) {
									return accept.includes(file.type);
								}).map(function (file) {
									return _this.validateOrCompressImage(file).then(function () {
										var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(newFile) {
											return regeneratorRuntime.wrap(function _callee$(_context) {
												while (1) {
													switch (_context.prev = _context.next) {
														case 0:
															return _context.abrupt('return', newFile);

														case 1:
														case 'end':
															return _context.stop();
													}
												}
											}, _callee, _this2);
										}));

										return function (_x2) {
											return _ref3.apply(this, arguments);
										};
									}());
								})).then(function (data) {
									onFilesUpload(data.filter(function (file) {
										return file;
									}) // Filter null / undefined files
									.slice(0, maxFiles) // Only accept maxFiles
									);
								});

							case 2:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2);
			}));

			return function (_x) {
				return _ref2.apply(this, arguments);
			};
		}(), _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(FileUploadDragDrop, [{
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps) {
			if (prevProps.enabled !== this.props.enabled) {
				if (this.refs.fileUpload) {
					this.refs.fileUpload.click();
				}
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props = this.props,
			    children = _props.children,
			    classes = _props.classes,
			    enabled = _props.enabled,
			    _props$accept = _props.accept,
			    accept = _props$accept === undefined ? null : _props$accept;


			return _react2.default.createElement(
				_reactFileDrop.FileDrop,
				{ onDrop: this.handleFileDrop },
				children,
				enabled && _react2.default.createElement('input', {
					type: 'file',
					className: classes.input,
					accept: accept,
					ref: 'fileUpload',
					required: true,
					onChange: function onChange(_ref4) {
						var _ref4$target = _ref4.target,
						    validity = _ref4$target.validity,
						    _ref4$target$files = _slicedToArray(_ref4$target.files, 1),
						    file = _ref4$target$files[0];

						return validity.valid && _this3.handleFileUpload(file);
					}
				})
			);
		}
	}]);

	return FileUploadDragDrop;
}(_react2.default.PureComponent);

exports.default = (0, _recompose.compose)((0, _styles.withStyles)(styles), (0, _reactI18next.withTranslation)(), (0, _reactRedux.connect)(null, function (dispatch) {
	return {
		processFileTooBig: function processFileTooBig(sizeInMegaBytes, t) {
			return dispatch((0, _actions.showSnackbarMessage)({
				text: t('app-core.file-upload.upload-failed-file-too-big', { size: sizeInMegaBytes || 50 }),
				variant: 'error'
			}));
		}
	};
}))(FileUploadDragDrop);